import { Backoffice, InitialData } from "types";
import { API } from "utils";

export const getInitialData = async (
  cognitoID: string,
): Promise<InitialData> => {
  const backoffice: Backoffice = await API.get({
    apiName: "backoffice",
    path: `/${cognitoID}`,
  });

  const [streetTypes, accountTypes] = await Promise.all([
    API.get({ apiName: "system", path: "/street-types" }),
    API.get({
      apiName: "accounts",
      path: "/types",
    }),
  ]);

  return {
    accountTypes,
    backoffice,
    streetTypes,
  };
};
